(function () {
  // Cache product JSON by handle
  var PRODUCT_JSON_CACHE = {};

  // ---------- helpers ----------
  function resolveSwatchInput(target) {
    if (target.matches('input[type="radio"].card-swatch,[data-variant-id].card-swatch')) return target;
    const label = target.closest('label');
    if (label) {
      const input = label.querySelector('input[type="radio"][data-variant-id]');
      if (input) return input;
    }
    const inputUp = target.closest('input[type="radio"][data-variant-id]');
    if (inputUp) return inputUp;
    return null;
  }

  function getProductJSON(handle) {
    if (PRODUCT_JSON_CACHE[handle]) return Promise.resolve(PRODUCT_JSON_CACHE[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (json) { PRODUCT_JSON_CACHE[handle] = json; return json; });
  }

  function findVariant(productJSON, variantId) {
    var idNum = parseInt(String(variantId), 10);
    if (!productJSON || !Array.isArray(productJSON.variants)) return null;
    return productJSON.variants.find(function (v) { return v.id === idNum; }) || null;
  }

  function normalizeSrc(url) {
    // strip protocol and query for comparisons
    try {
      var u = new URL(url, window.location.origin);
      return u.hostname + u.pathname;
    } catch (e) {
      return String(url).replace(/^https?:\/\//, '').split('?')[0];
    }
  }

  function toWidth(url, w) {
    try {
      var u = new URL(url, window.location.origin);
      if (!u.searchParams.has('width')) u.searchParams.set('width', String(w));
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function preload(url) {
    if (!url) return;
    var img = new Image();
    img.src = url;
  }

  // ---------- image picking ----------
  function getPrimaryImageURL(productJSON, variant) {
    if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (productJSON && productJSON.images && productJSON.images[0]) return productJSON.images[0];
    return null;
  }

  // Choose the **next** image after the variant's image position for hover
  function getHoverImageURL(productJSON, variant, primaryUrl) {
    if (!productJSON || !Array.isArray(productJSON.images) || productJSON.images.length < 2) return null;

    // If variant has a position, try the next image
    if (variant && variant.featured_image && typeof variant.featured_image.position === 'number') {
      var pos1 = variant.featured_image.position; // 1-based
      var nextIndex = pos1; // 0-based index of "next"
      if (nextIndex < productJSON.images.length) {
        var nextUrl = productJSON.images[nextIndex];
        if (normalizeSrc(nextUrl) !== normalizeSrc(primaryUrl)) return nextUrl;
      }
    }

    // Fallback: find primary in images[], then choose the next one
    var primaryIndex = productJSON.images.findIndex(function (u) { return normalizeSrc(u) === normalizeSrc(primaryUrl); });
    if (primaryIndex !== -1) {
      var cand = productJSON.images[(primaryIndex + 1) % productJSON.images.length];
      if (normalizeSrc(cand) !== normalizeSrc(primaryUrl)) return cand;
    }

    // If all else fails, pick the second image in the array
    var second = productJSON.images[1];
    return normalizeSrc(second) === normalizeSrc(primaryUrl) ? null : second;
  }

  // ---------- DOM updates ----------
  function updateCardLinks(cardEl, productHandle, variantId) {
    var links = cardEl.querySelectorAll('a[href*="/products/"]');
    links.forEach(function (a) {
      try {
        var href = new URL(a.href, window.location.origin);
        if (!href.pathname.includes('/products/' + productHandle)) return;
        href.searchParams.set('variant', String(variantId));
        a.href = href.toString();
      } catch (e) {
        var base = '/products/' + productHandle;
        var idx = a.href.indexOf(base);
        if (idx !== -1) {
          a.href = a.href.substring(0, idx + base.length) + '?variant=' + String(variantId);
        }
      }
    });
  }

  function updatePrimaryImage(cardEl, imageUrl) {
    if (!imageUrl) return;
    var media = cardEl.querySelector('.card__media');
    if (!media) return;
    var mainImg = media.querySelector('img'); // first image in container is primary
    if (!mainImg) return;

    var url533 = toWidth(imageUrl, 533);
    preload(url533);
    mainImg.src = url533;
    mainImg.removeAttribute('srcset'); // avoid stale responsive set
  }

  function updateHoverImage(cardEl, hoverUrl) {
    if (!hoverUrl) return; // feature may be off or no suitable image
    var media = cardEl.querySelector('.card__media .media');
    if (!media) return;
    var imgs = media.querySelectorAll('img');
    if (imgs.length < 2) return; // secondary hover image not rendered, do nothing
    var hoverImg = imgs[1];

    var url533 = toWidth(hoverUrl, 533);
    preload(url533);
    hoverImg.src = url533;
    hoverImg.removeAttribute('srcset');
  }

  // ---------- main handler ----------
  function onCardSwatchChange(event) {
    // Avoid double-run for radios when listening to both click & change
    if (event.type === 'click' && event.target.type === 'radio') return;

    var input = resolveSwatchInput(event.target);
    if (!input) return;

    var card = input.closest('.card-wrapper.product-card-wrapper');
    if (!card) return;

    var productHandle = input.dataset.productHandle;
    var variantId = input.dataset.variantId;
    if (!productHandle || !variantId) return;

    // Update links immediately
    updateCardLinks(card, productHandle, variantId);

    // Fetch product JSON once, then compute & swap images
    getProductJSON(productHandle)
      .then(function (productJSON) {
        var variant = findVariant(productJSON, variantId);
        var primaryUrl = getPrimaryImageURL(productJSON, variant);
        var hoverUrl = getHoverImageURL(productJSON, variant, primaryUrl);

        updatePrimaryImage(card, primaryUrl);
        updateHoverImage(card, hoverUrl);
      })
      .catch(function (err) {
        console.debug('Variant update failed', err);
      });
  }

  // ---------- FF: Page-load initialization for filtered variants ----------
  // This fixes hover images when page loads with filter params or after AJAX filter updates
  function initCardHoverImages(scope) {
    var container = scope || document;
    
    // Get all product cards in scope
    var cards = container.querySelectorAll('.card-wrapper.product-card-wrapper');
    
    cards.forEach(function(card) {
      // Skip if already initialized
      if (card.dataset.ffHoverInit === '1') return;
      card.dataset.ffHoverInit = '1';
      
      var media = card.querySelector('.card__media .media');
      if (!media) return;
      
      var imgs = media.querySelectorAll('img');
      if (imgs.length < 2) return; // No hover image to fix
      
      var mainImg = imgs[0];
      var hoverImg = imgs[1];
      
      // Get the product handle from a link or swatch
      var productLink = card.querySelector('a[href*="/products/"]');
      var swatchInput = card.querySelector('input.card-swatch[data-product-handle]');
      
      var productHandle = null;
      var variantId = null;
      
      if (productLink) {
        try {
          var url = new URL(productLink.href, window.location.origin);
          var pathParts = url.pathname.split('/');
          var productsIndex = pathParts.indexOf('products');
          if (productsIndex !== -1 && pathParts[productsIndex + 1]) {
            productHandle = pathParts[productsIndex + 1].split('?')[0];
          }
          variantId = url.searchParams.get('variant');
        } catch (e) {}
      }
      
      if (!productHandle && swatchInput) {
        productHandle = swatchInput.dataset.productHandle;
      }
      
      if (!productHandle) return;
      
      // Get the current main image src to find the correct hover image
      var currentMainSrc = mainImg.src || mainImg.srcset;
      if (!currentMainSrc) return;
      
      // Fetch product JSON and update hover image
      getProductJSON(productHandle)
        .then(function(productJSON) {
          if (!productJSON || !productJSON.images || productJSON.images.length < 2) return;
          
          // Find which variant matches the current main image
          var matchedVariant = null;
          
          if (variantId) {
            matchedVariant = findVariant(productJSON, variantId);
          }
          
          // If no variant from URL, try to match by image
          if (!matchedVariant) {
            var normalizedMain = normalizeSrc(currentMainSrc);
            for (var i = 0; i < productJSON.variants.length; i++) {
              var v = productJSON.variants[i];
              if (v.featured_image && v.featured_image.src) {
                if (normalizeSrc(v.featured_image.src) === normalizedMain) {
                  matchedVariant = v;
                  break;
                }
              }
            }
          }
          
          // Get the correct hover image for this variant
          var primaryUrl = getPrimaryImageURL(productJSON, matchedVariant);
          var hoverUrl = getHoverImageURL(productJSON, matchedVariant, primaryUrl || currentMainSrc);
          
          if (hoverUrl) {
            var url533 = toWidth(hoverUrl, 533);
            hoverImg.src = url533;
            hoverImg.removeAttribute('srcset');
          }
        })
        .catch(function(err) {
          console.debug('Card hover init failed for', productHandle, err);
        });
    });
  }

  // Expose for facets.js to call after AJAX updates
  window.FFInitCardHoverImages = initCardHoverImages;

  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('change', onCardSwatchChange);
    document.addEventListener('click', onCardSwatchChange);
    
    // Initialize hover images on page load
    // Small delay to ensure images are loaded
    setTimeout(function() {
      initCardHoverImages();
    }, 100);
  });
})();